import React from "react";

import { type ForecastVariables } from "@north-beam/nb-client-side";

import { BudgetAllocationTable } from "./table";

export function UpdateBudgetPacingAllocation({
  getForecast,
  allowForecastAdoption,
  onAdoptForecast,
  forecastError,
}: {
  getForecast: (forecastInput: ForecastVariables) => Promise<unknown>;
  allowForecastAdoption: boolean;
  onAdoptForecast: () => Promise<void>;
  forecastError: boolean;
}) {
  return (
    <div className="flex p-5 flex-col max-w-full">
      <div className="font-semibold">Update Budget Allocation</div>
      <div className="text-subtitle text-sm mt-1">
        Edit the mix percentage or value for any channel below or drag the bars
        to adjust.
      </div>
      <BudgetAllocationTable
        getForecast={getForecast}
        allowForecastAdoption={allowForecastAdoption}
        onAdoptForecast={onAdoptForecast}
        forecastError={forecastError}
      />
    </div>
  );
}
